














import {defineComponent, PropType} from "@vue/composition-api";
import {ParameterEntityInterface, ProjectEntityInterface} from "@tool/tool.types";
import ProjectReportsLayout from "@tool/Pages/App/Project/Reports/layout/ProjectReportsLayout.vue";
import {DateRangeInterface, ProjectReportSingleFilterInterface} from "@tool/Pages/App/Project/Reports/reports.types";
import {ResourceCollectionInterface} from "@base/base.types";
import useInertiaTable from "@tool/Helpers/useInertiaTable";
import ThemeBlock from "@base/Components/theme/ThemeBlock.vue";
import InertiaDatatable from "@base/Components/InertiaDatatable.vue";

export default defineComponent({
    components: {
        ProjectReportsLayout,
        ThemeBlock,
        InertiaDatatable,
    },
    props: {
        project: {
            type: Object as PropType<ProjectEntityInterface>,
            required: true
        },
        dateRange: {
            type: Object as PropType<DateRangeInterface<string>>,
            required: true
        },
        filters: {
            type: Array as PropType<ProjectReportSingleFilterInterface<any>[]>,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        parameters: {
            type: Object as PropType<ResourceCollectionInterface<ParameterEntityInterface>>,
            required: true
        }
    },
    setup(props) {
        const table = useInertiaTable(props.parameters, [
            {
                key: 'name',
                label: 'Name'
            },
            {
                key: 'clicks',
                label: 'Lifetime Clicks'
            },
            {
                key: 'clicks_period',
                label: 'Clicks'
            },
            {
                key: 'actions',
                label: 'Actions',
                class: 'actions'
            },
        ]);

        const addToFilterHref = (parameter: ParameterEntityInterface) => {
            let params: any = route().params;
            params['filter_' + parameter.type] = parameter.id;

            return route('app.project.reports.index', params);
        }

        const statsForParameterHref = (param: ParameterEntityInterface) => {
            let params: any = {tool_project_entity: props.project.slug};

            params['filter_' + props.type] = param.id

            return route('app.project.reports.index', params);
        }

        return {
            table,
            addToFilterHref,
            statsForParameterHref,
        };
    }
})
